import axios from "axios";

const request = axios.create({
  baseURL:
    process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "https://api.bellhopt.com/api/v1"
      : "https://api.bellhopt.com/api/v1",

  withCredentials: true,
});

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!error.response) {
      const err = {
        error: "No response from the server, please try again later",
      };
      const data = { response: { data: err } };
      return Promise.reject(data);
    }
    // On 401 (e.g. sign-in token expired): clear host auth and redirect to login
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url ?? "";
      if (requestUrl.includes("/driver/")) {
        // Driver request — do not clear host; let driver screen handle
        return Promise.reject(error);
      }
      // Host request — clear persisted host auth and redirect to /login (replace so Back doesn’t return to expired session)
      localStorage.removeItem("hostInfo");
      window.location.replace("/login");
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default request;
